import { add } from "ionicons/icons";
import { CorporateAddress } from "../../entity/corporate/corprateAddress";

export class CorporateDetails {
    corporateName: string
    branch: string
    mobile1: number
    primaryContactPerson: string
    gstNumber: string
    email: string
    status: string
    email2?: string
    email3?: string
    mobile2? : number
    landline? : string
    secondaryContactPerson? : string
    address? : CorporateAddress
    retiredReason?: string
    branchHdrId? : string
    constructor(corporateName: string, branch: string, mobile1: number, primaryContactPerson: string, gstNumber: string, email: string, status: string, email2?: string, email3?: string,  mobile2? : number, landline? : string, secondaryContactPerson? : string, address? : CorporateAddress, retiredReason?: string, branchHdrId?:string){
        this.corporateName = corporateName
        this.branch = branch
        this.mobile1 = mobile1
        this.primaryContactPerson = primaryContactPerson
        this.gstNumber = gstNumber
        this.email = email
        this.status = status
        this.email2 = email2
        this.email3 = email3
        this.mobile2 = mobile2
        this.landline = landline
        this.secondaryContactPerson = secondaryContactPerson
        this.address = address
        this.retiredReason = retiredReason,
        this.branchHdrId = branchHdrId

    }
}

export class BranchStatus {
    id: string
    name: string
    remarks?: string
    additionalInfo?: string
    constructor(id: string, name: string, remarks: string, additionalInfo: string) {
        this.id = id;
        this.name = name;
        this.remarks = remarks;
        this.additionalInfo = additionalInfo;
    }
}

export class ChargerOverallStatus {
    id: string
    name: string
    remarks?: string
    additionalInfo?: string
    constructor(id: string, name: string, remarks: string, additionalInfo: string) {
        this.id = id;
        this.name = name;
        this.remarks = remarks;
        this.additionalInfo = additionalInfo;
    }
}
export class ChargerOtherStatus {
    id: string
    name: string
    remarks?: string
    additionalInfo?: string
    constructor(id: string, name: string, remarks: string, additionalInfo: string) {
        this.id = id;
        this.name = name;
        this.remarks = remarks;
        this.additionalInfo = additionalInfo;
    }
}
export class UserBranchRelationshipStatus {
    id: string
    name: string
    remarks?: string
    additionalInfo?: string
    constructor(id: string, name: string, remarks: string, additionalInfo: string) {
        this.id = id;
        this.name = name;
        this.remarks = remarks;
        this.additionalInfo = additionalInfo;
    }
}

export class UserTariffType {
    id: string
    name: string
    remarks?: string
    additionalInfo?: string
    constructor(id: string, name: string, remarks: string, additionalInfo: string) {
        this.id = id;
        this.name = name;
        this.remarks = remarks;
        this.additionalInfo = additionalInfo;
    }
}
export class EVStationBranch {
    corporateId: string
    corporateName: string
    branchId: string
    branchName: string
    status: BranchStatus

    constructor(corporateId: string, corporateName: string, branchId: string, branchName: string, status: BranchStatus) {
        this.corporateId = corporateId;
        this.corporateName = corporateName;
        this.branchId = branchId;
        this.branchName = branchName;
        this.status = status;
    }
}